/* eslint-env browser */
import axios from 'axios'
import * as React from 'react'

import withTranslator from '../TranslatorProvider'

const PropTypes = require('prop-types')
const { CancelToken } = axios

const GridFilter = require('./GridFilter')
const LargeGearItem = require('./LargeGearItem')

class FilteredGearGrid extends React.Component {
  constructor(props) {
    super(props)

    const {
      sortBy = 'usage',
      data,
      productCategories,
      translate,
      brandsIds = [],
      productCategoriesIds = [],
      speciesIds = [],
    } = this.props

    this.state = {
      filters: {
        brandsIds,
        productCategoriesIds,
        speciesIds,
      },
      sort: sortBy,
      loading: false,
      data: data || [],
      productCategoriesById: productCategories.reduce((aggreg, elt) => {
        aggreg[elt.id] = elt
        return aggreg
      }, {}),
      sortOptions: [
        { key: 'usage', value: 'usage', display: translate('gears.gridSearch.sort.by.usage') },
        { key: 'date', value: 'date', display: translate('gears.gridSearch.sort.by.date') },
      ],
    }
    this.onChangeCategories = this.onChangeCategories.bind(this)
    this.onChangeSpecies = this.onChangeSpecies.bind(this)
    this.onChangeSort = this.onChangeSort.bind(this)
    this.updateResults = this.updateResults.bind(this)

    this.searchCancelSource = CancelToken.source()
  }

  onChangeCategories(newValue) {
    this.setState(
      prevState => ({
        filters: {
          ...prevState.filters,
          productCategoriesIds: [newValue],
        },
      }),
      this.updateResults
    )
  }

  onChangeSpecies(newValue) {
    this.setState(
      prevState => ({
        filters: {
          ...prevState.filters,
          speciesIds: [newValue],
        },
      }),
      this.updateResults
    )
  }

  onChangeSort(newValue) {
    this.setState(
      {
        sort: newValue,
      },
      this.updateResults
    )
  }

  updateResults() {
    this.searchCancelSource.cancel()
    this.searchCancelSource = CancelToken.source()

    const { permanentFilters = {} } = this.props
    const { filters = {}, sort } = this.state

    let queryParams = {
      ...filters,
      ...permanentFilters,
    }

    this.setState({ loading: true })

    queryParams = Object.keys(queryParams)
      .map(key => ({ key, array: queryParams[key].filter(id => id !== '__ALL__') }))
      .filter(obj => obj.array.length > 0)
      .reduce((aggreg, obj) => {
        aggreg[obj.key] = obj.array
        return aggreg
      }, {})

    axios
      .get('/api/gear/search', {
        cancelToken: this.searchCancelSource.token,
        params: {
          ...queryParams,
          sortBy: sort,
        },
      })
      .then(res => {
        // const totalCount = (parseInt(res.headers['x-total-count'], 10) || 0);
        this.setState(
          {
            data: res.data || [],
            loading: false,
          },
          () => {
            // this.changeUrlByState();
            // this.changeTitle();
          }
        )
      })
      .catch(err => {
        this.setState({ loading: false })
      })
  }

  render() {
    const { productCategories, species, translate, introTextKey, introTranslateOptions, host, hostPath } = this.props
    const { filters, sort, data, productCategoriesById, sortOptions, loading } = this.state

    const productCategoriesFilter = (productCategories || []).map(elt => ({
      key: elt.id,
      value: elt.id,
      display: elt.name,
    }))
    const speciesFilter = (species || []).map(elt => ({
      key: elt.id,
      value: elt.id,
      display: elt.name,
    }))

    let introPhrase
    if (introTextKey) {
      const k = `gears.gridSearch.texts.${introTextKey}.search`
      const selectedCategories = productCategoriesFilter.filter(
        elt => elt.value !== '__ALL__' && filters.productCategoriesIds.indexOf(elt.value) > -1
      )
      const selectedSpecies = speciesFilter.filter(
        elt => elt.value !== '__ALL__' && filters.speciesIds.indexOf(elt.value) > -1
      )

      const phrases = []
      if (selectedCategories.length > 0) {
        phrases.push(
          translate(`${k}.gear.specific`, {
            ...introTranslateOptions,
            categories: selectedCategories.map(elt => elt.display).join(', '),
          })
        )
      } else {
        phrases.push(translate(`${k}.gear.all`, introTranslateOptions))
      }
      if (selectedSpecies.length > 0) {
        phrases.push(
          translate(`${k}.species.specific`, {
            ...introTranslateOptions,
            speciesNames: selectedSpecies.map(elt => elt.display).join(', '),
          })
        )
      } else {
        phrases.push(translate(`${k}.species.all`, introTranslateOptions))
      }
      phrases.push(translate(`${k}.sortedBy.${sort}`))
      introPhrase = phrases.join('')
    }

    const otherQueryParams = {
      'productCategoriesIds[]': filters.productCategoriesIds,
      'speciesIds[]': filters.speciesIds,
      sortBy: sort,
    }

    return (
      <div className="has-padding-bottom-medium">
        <div className="content has-text-centered" style={{ marginBottom: introPhrase ? 0 : undefined }}>
          {productCategoriesFilter.length > 0 && (
            <GridFilter
              label={translate('gears.gridSearch.filters.categories.title')}
              allLabel={translate('gears.gridSearch.filters.categories.all')}
              options={productCategoriesFilter}
              onChange={this.onChangeCategories}
              value={filters.productCategoriesIds[0]}
              changeURLQueryParam="productCategoriesIds[]"
              host={host}
              hostPath={hostPath}
              otherQueryParams={otherQueryParams}
            />
          )}
          {species.length > 0 && (
            <GridFilter
              label={translate('gears.gridSearch.filters.species.title')}
              allLabel={translate('gears.gridSearch.filters.species.all')}
              options={speciesFilter}
              onChange={this.onChangeSpecies}
              value={filters.speciesIds[0]}
              changeURLQueryParam="speciesIds[]"
              host={host}
              hostPath={hostPath}
              otherQueryParams={otherQueryParams}
            />
          )}
          <GridFilter
            label={translate('gears.gridSearch.sort.title')}
            options={sortOptions}
            onChange={this.onChangeSort}
            value={sort}
            changeURLQueryParam="sortBy"
            host={host}
            hostPath={hostPath}
            otherQueryParams={otherQueryParams}
          />
        </div>
        {introPhrase && <p className="content has-text-centered is-size-7 has-margin-top-zero">{introPhrase}</p>}
        <div style={{ minHeight: 400 }}>
          <div className="columns is-centered is-mobile is-multiline horizontal-scroll-container is-variable is-1">
            {loading && <div className="loader is-size-1 is-primary is-large is-self-centered" />}
            {!loading &&
              data.map(elt => (
                <div key={elt.productArticleId} className="column is-6-mobile is-3-tablet animated fadeIn faster">
                  <LargeGearItem gear={elt} productCategory={productCategoriesById[elt.productCategoryId]} />
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  }
}

FilteredGearGrid.propTypes = {
  productCategories: PropTypes.array,
  species: PropTypes.array,
  translate: PropTypes.func.isRequired,
  permanentFilters: PropTypes.object.isRequired,
  sortBy: PropTypes.string,
  hideBrandSelect: PropTypes.bool,
  data: PropTypes.array,
  introTextKey: PropTypes.string,
  introTranslateOptions: PropTypes.object,
  brandsIds: PropTypes.array,
  productCategoriesIds: PropTypes.array,
  speciesIds: PropTypes.array,
  host: PropTypes.string.isRequired,
  hostPath: PropTypes.string.isRequired,
}

FilteredGearGrid.defaultProps = {
  productCategories: [],
  species: [],
  sortBy: 'usage',
  hideBrandSelect: false,
  data: [],
  introTextKey: null,
  introTranslateOptions: {},
  brandsIds: [],
  productCategoriesIds: [],
  speciesIds: [],
}

module.exports = withTranslator(FilteredGearGrid)
